<mat-icon *ngIf="locked !== null"
  (click)="!readonly ? changeLock() : null"
  [ngClass]="[iconSizeClass || 'icon-size-4']"
  class="text-current"
  [svgIcon]="locked ? 'heroicons_solid:lock-closed' : 'heroicons_solid:lock-open'"
  [id]="buttonId"
></mat-icon>
